import { Logo as UnstyledLogo } from 'components/Logo';
import styled, { css, DefaultTheme } from 'styled-components';
import { Col as GridCol } from 'components/GridSystem';

type CopyrightTextProps = {
  variant: 'primary' | 'secondary' | 'third';
};

const modifiers = (theme: DefaultTheme) => ({
  primary: css`
    color: ${theme.colors.neutralDark80};
  `,
  secondary: css`
    color: ${theme.colors.globalWhite100};
  `,
  third: css`
    color: ${theme.colors.globalWhite100};
    margin-top: 0;
  `,
});

const wrapperModifiers = {
  third: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.purple100};
  `,
};

export const Wrapper = styled.footer<CopyrightTextProps>`
  ${({ theme, variant }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 4rem 0;

    ${variant === 'third' && wrapperModifiers.third(theme)}
  `}
`;

export const Col = styled(GridCol)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled(UnstyledLogo)`
  width: 230px;
  object-fit: contain;

  @media screen and (max-width: 1024px) {
    width: 154px;
  }
`;

export const CopyrightText = styled.p<CopyrightTextProps>`
  ${({ variant, theme }) => css`
    font-size: 1.2rem;
    text-align: center;
    margin: 24px 0 0 0;

    ${modifiers(theme)[variant]}
  `};
`;

export const FooterLink = styled.a`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2rem;

    color: ${theme.colors.purple100};

    text-decoration: none;

    &:nth-child(1) {
      position: relative;

      &::after {
        content: '';
        height: 12px;
        width: 2px;

        position: absolute;
        right: -8px;
        top: 50%;
        transform: translateY(-50%);

        background-color: ${theme.colors.purple100};
      }
    }
  `}
`;

export const FooterLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;

  gap: 12px;
`;
